<div class="skl-applications" aria-busy="true" aria-label="Loading Application Portfolio">

  <!-- Title bar -->
  <div class="d-flex align-items-center mb-3">
    <div class="flex-grow-1 flex-basis-0">
      <app-skeleton width="60px" height="28px" borderRadius="4px" marginBottom="0"></app-skeleton>
    </div>
    <div class="text-center flex-shrink-0 skl-title-block">
      <app-skeleton width="220px" height="28px" borderRadius="4px" marginBottom="0" class="d-block mx-auto"></app-skeleton>
      <app-skeleton width="290px" height="18px" borderRadius="3px" marginBottom="0" class="d-block mx-auto"></app-skeleton>
    </div>
    <div class="flex-grow-1 flex-basis-0"></div>
  </div>

  <!-- Toolbar: filter dropdowns -->
  @if (showOwnerFilter || showExcludedFilter) {
    <div class="d-flex align-items-end mb-2 gap-3">
      @if (showOwnerFilter) {
        <div class="skl-filter-group">
          <app-skeleton width="100px" height="24px" borderRadius="3px" marginBottom="8px"></app-skeleton>
          <app-skeleton width="220px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
      }
      @if (showExcludedFilter) {
        <div class="skl-filter-group">
          <app-skeleton width="86px" height="24px" borderRadius="3px" marginBottom="8px"></app-skeleton>
          <app-skeleton width="220px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
      }
    </div>
  }

  <!-- Rejected note (mirrors the real .rejected-note paragraph) -->
  @if (showExcludedFilter) {
    <div class="mb-2">
      <app-skeleton width="320px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
    </div>
  }

  <!-- Data grid -->
  <div class="skl-grid">

    <!-- Group header row -->
    <div class="skl-group-header-row">
      <!-- sticky cols spacer -->
      <div class="skl-col skl-col-appid"></div>
      <div class="skl-col skl-col-name"></div>
      <div class="skl-col skl-col-crit"></div>
      <div class="skl-col skl-col-users"></div>
      <div class="skl-col skl-col-tco"></div>
      <div class="skl-col skl-col-incidents"></div>
      <div class="skl-col skl-col-platform"></div>
      <!-- AI CMDB group -->
      <div class="skl-col-group skl-col-group-cmdb">
        <app-skeleton width="80px" height="11px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <!-- AI Code group -->
      <div class="skl-col-group skl-col-group-code">
        <app-skeleton width="120px" height="11px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-assignedrole"></div>
      @if (showAssignmentDate) {
        <div class="skl-col skl-col-assignmentdate"></div>
      }
      <!-- action spacer -->
      <div class="skl-col skl-col-action"></div>
    </div>

    <!-- Column header row -->
    <div class="skl-header-row">
      <div class="skl-col skl-col-appid">
        <app-skeleton width="55px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-name">
        <app-skeleton width="75px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-crit">
        <app-skeleton width="110px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-users">
        <app-skeleton width="44px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-tco">
        <app-skeleton width="58px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-incidents">
        <app-skeleton width="62px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-platform">
        <app-skeleton width="100px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-readiness">
        <app-skeleton width="90px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-analysis">
        <app-skeleton width="88px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-keyreason">
        <app-skeleton width="68px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-recommendation">
        <app-skeleton width="108px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-complexity">
        <app-skeleton width="88px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-codekeyreason">
        <app-skeleton width="68px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      <div class="skl-col skl-col-assignedrole">
        <app-skeleton width="78px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
      @if (showAssignmentDate) {
        <div class="skl-col skl-col-assignmentdate">
          <app-skeleton width="96px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
      }
      <div class="skl-col skl-col-action">
        <app-skeleton width="50px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      </div>
    </div>

    <!-- Filter row — input-like boxes per column -->
    <div class="skl-filter-row">
      <div class="skl-col skl-col-appid">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-name">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-crit">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-users">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-tco">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-incidents">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-platform">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-readiness">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-analysis">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-keyreason">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-recommendation">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-complexity">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-codekeyreason">
        <div class="skl-filter-input"></div>
      </div>
      <div class="skl-col skl-col-assignedrole">
        <div class="skl-filter-input"></div>
      </div>
      @if (showAssignmentDate) {
        <div class="skl-col skl-col-assignmentdate">
          <div class="skl-filter-input"></div>
        </div>
      }
      <div class="skl-col skl-col-action"></div>
    </div>

    <!-- Data rows -->
    @for (row of rows; track row) {
      <div class="skl-data-row">
        <div class="skl-col skl-col-appid">
          <app-skeleton width="70%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-name">
          <app-skeleton width="85%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-crit">
          <app-skeleton width="65%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-users">
          <app-skeleton width="55%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-tco">
          <app-skeleton width="70%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-incidents">
          <app-skeleton width="50%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-platform">
          <app-skeleton width="75%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-readiness">
          <app-skeleton width="40%" height="13px" borderRadius="3px" marginBottom="0" class="d-block mx-auto"></app-skeleton>
        </div>
        <div class="skl-col skl-col-analysis">
          <app-skeleton width="70%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-keyreason">
          <app-skeleton width="80%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-recommendation">
          <app-skeleton width="75%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-complexity">
          <app-skeleton width="65%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-codekeyreason">
          <app-skeleton width="80%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-col skl-col-assignedrole">
          <app-skeleton width="72%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
        @if (showAssignmentDate) {
          <div class="skl-col skl-col-assignmentdate">
            <app-skeleton width="76%" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
          </div>
        }
        <div class="skl-col skl-col-action">
          <app-skeleton width="110px" height="28px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
      </div>
    }

    <!-- Pagination bar -->
    <div class="skl-pagination-bar">
      <app-skeleton width="160px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
      <div class="skl-pagination-buttons">
        @for (btn of [1,2,3,4]; track btn) {
          <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
        }
      </div>
    </div>

  </div>
</div>
